module.exports = __webpack_public_path__ + "static/img/share-receive_success.842b926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/share-receive_success.png
// module id = ftol
// module chunks = 23